<!doctype html>
<block-ui [template]="blockTemplate">
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </head>

    <body>
      <app-header></app-header>
      <section class="banner mt-10">
        <div class="container">
          <div class="row background-mobile">
            <div class="col-md-3 col-sm-12 espacamento-top-mobile" style="margin-top: 19%">
              <h4 class="card-title client-title" style="margin-top: 9%">
                <span class="area">
                  Espaço do
                  <br />
                </span>
                <span class="cliente">Cliente</span>
              </h4>
            </div>

            <div class="col-md-6 offset-md-6 banner-card">
              <div
                class="card"
                style="margin-top: 221px; margin-bottom: 43%; border-radius: 20px !important; width: 100% !important">
                <ul class="list-group list-group-flush">
                  <div class="card-body">
                    <h4 class="card-title client-title">ACESSE AQUI OS PRINCIPAIS SERVIÇOS:</h4>
                  </div>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://geia.mdscloud.com.br/portal/public/login.jsf" target="_blank">Imposto de Renda</a>
                    <!-- <a data-toggle="modal" data-target="#modal-historico-financeiro">Imposto de Renda</a> -->
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a data-toggle="modal" data-target="#modal-aviso">2º Via de Boleto</a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://geia.mdscloud.com.br/portal/public/login.jsf" target="_blank">
                      Recibos e Pagamentos
                    </a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://geia.mdscloud.com.br/portal/public/login.jsf" target="_blank">
                      Recibos e Reembolso
                    </a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://geia.mdscloud.com.br/portal/public/login.jsf" target="_blank">
                      Relatório de Coparticipação
                    </a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://www.portal.geia.com.br/conta/login" target="_blank">Minha Saúde</a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://www.portal.geia.com.br/conta/login" target="_blank">Contrato Plano de Saúde</a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://www.portal.geia.com.br/conta/login" target="_blank">Contrato Odontológico</a>
                  </li>
                  <li class="list-group-item list-group-item-action">
                    <a href="https://www.portal.geia.com.br/conta/login" target="_blank">Acesse sua proposta</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <app-email-contact></app-email-contact>
      <app-portal-footer></app-portal-footer>
      <app-nexus-chat></app-nexus-chat>

      <div class="cantainer">
        <!-- [ Modal #1 ] -->
        <div class="modal fade section-gap-80" id="modal-aviso" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <button type="button" class="close" data-dismiss="modal"><i class="icon-xs-o-md"></i></button>
              <div class="modal-header">
                <h4 class="modal-title caps"><strong>AVISO IMPORTANTE!</strong></h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <p>
                    Ao emitir o seu boleto certifique-se que o código em destaque (imagem abaixo) corresponde
                    obrigatoriamente ao código do
                    <b>Banco Itaú (341)</b>
                    , e que todos os dados estão corretos. Caso o código do banco ou alguma informação esteja diferente,
                    não efetue o pagamento e entre em contato com os centrais de atendimento Géia. Nosso horário de
                    atendimento é de segunda a sexta das 08h30 às 17h30. Telefone/WhatsApp:
                    <a
                      class="cursor-pointer"
                      href="https://api.whatsapp.com/send?phone=551136602000&text=oi"
                      target="_blank">
                      (11) 3660-2000
                    </a>
                  </p>
                  <div class="bs-callout-warning callout-round callout-bordered callout-transparent mt-1">
                    <div class="media align-items-stretch">
                      <div class="media-left d-flex align-items-center bg-warning p-2">
                        <i class="white fa fa-exclamation-triangle font-medium-5"></i>
                      </div>
                      <div class="media-body p-1">
                        <strong>Importante:</strong>
                        <p>Não enviamos a numeração do boleto via WhatsApp.</p>
                      </div>
                    </div>
                  </div>
                  <img
                    class="mt-1"
                    style="width: 99%"
                    src="https://site-geia.azurewebsites.net/Content/img/boleto-inform.PNG" />
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-info round"
                  data-toggle="modal"
                  data-target="#modal-2-via"
                  data-dismiss="modal">
                  Entendi, Emitir Boleto
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- [ Modal #2 ] -->
        <div class="modal fade section-gap-80" id="modal-2-via" tabindex="-1" style="overflow: scroll">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <button type="button" class="close" data-dismiss="modal"><i class="icon-xs-o-md"></i></button>
              <div class="modal-header">
                <h4 class="modal-title caps"><strong>Emissão 2ª via do boleto</strong></h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- <form #f1> -->
              <div class="modal-body">
                <div #f1 class="form-group">
                  <form name="f1" action="https://ww2.itau.com.br/2viabloq/frames.asp" method="post">
                    <div class="input-group">
                      <input
                        name="numDocumento"
                        type="text"
                        [(ngModel)]="numDocumento"
                        mask="000.000.000-00||00.000.000/0000-00"
                        required
                        type="text"
                        class="form-control"
                        placeholder="CPF/CNPJ do titular ou responsável financeiro" />

                      <input #strTrancInput type="hidden" name="strTranc" class="form-control" />

                      <span class="input-group-btn">
                        <button class="btn btn-info" type="button" (click)="pesquisarDocumento(numDocumento)">
                          Pesquisar
                        </button>
                      </span>
                    </div>
                  </form>
                </div>

                <div class="mt-1">
                  <h4 *ngIf="!isExistBoleto || isResultado" class="modal-title caps">
                    <strong>Pesquisa de boletos</strong>
                  </h4>
                  <div class="mt-1" *ngIf="!isExistBoleto">
                    <span>CPF/CNPJ não encontrado.</span>
                  </div>

                  <div class="mt-1" *ngIf="isResultado">
                    <p>
                      <b>Empresa:</b>
                      {{ result.Cedente }}
                    </p>
                    <p>
                      <b>Cliente:</b>
                      {{ result.Sacado }}
                    </p>
                    <div class="card-body">
                      <div class="badge badge-warning">Selecione o boleto que deseja visualizar</div>
                    </div>
                    <div *ngIf="listaBloquete.length == 0">VAZIA</div>
                    <div class="table-responsive mt-1">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Nosso Número</th>
                            <th scope="col">N.º documento</th>
                            <th scope="col">Vencimento</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Emitir</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let itemBloquete of listaBloquete">
                            <td>
                              {{ itemBloquete.NOSSONUMERO }}
                            </td>
                            <td>{{ itemBloquete.NUMERODOCUMENTO }}</td>
                            <td>{{ itemBloquete.VENCIMENTO }}</td>
                            <td>{{ itemBloquete.VALOR }}</td>

                            <td>
                              <a target="_blank">
                                <img
                                  (click)="envia(itemBloquete.LINK)"
                                  width="50% !important"
                                  class="cursor-pointer"
                                  src="../../../../assets/app-assets/images/ícones-geia/boleto.png" />
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <span class="mt-1">
                      Para boletos com data de vencimento superior a 60 dias em atraso, entre em contato
                      <a
                        class="cursor-pointer"
                        href="https://api.whatsapp.com/send?phone=551136602000&text=oi"
                        target="_blank">
                        <b>conosco.</b>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-warning round"
                  data-toggle="modal"
                  data-target="#modal-historico-financeiro"
                  data-dismiss="modal">
                  Histórico Financeiro
                </button>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>

        <!-- [ Modal #3 ] -->
        <div class="modal fade section-gap-80" id="modal-historico-financeiro" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <button type="button" class="close" data-dismiss="modal"><i class="icon-xs-o-md"></i></button>
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <div class="container">
                    <div class="row container" style="margin: auto">
                      <p>Na próxima tela, digite o usúario e senha e selecione o acesso conforme abaixo:</p>

                      <div class="col-sm">
                        <div class="mt-1">
                          <!-- -->
                          <div
                            class="bs-callout-danger callout-border-left callout-square callout-bordered callout-transparent mt-1 p-1">
                            <p>
                              Usúario:
                              <b>Seu CPF</b>
                            </p>
                            <p>
                              Senha:
                              <b>Seu CPF</b>
                            </p>
                            <p>
                              Acesso:
                              <b></b>
                              Beneficiário
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm">
                        <img
                          class="mt-1"
                          style="width: 70%"
                          src="../../../../assets/app-assets/images/ilustracao/fakplan-info.png" />
                      </div>
                    </div>
                    <div class="card-body p-2 p-md-3 text-center">
                      <span
                        class="badge badge-info d-block d-md-inline-block"
                        style="white-space: normal; word-break: break-word; line-height: 1.4">
                        <i class="fa fa-shield-alt mr-1"></i>
                        Dica de segurança: Sugerimos que após o 1º acesso, você altere sua senha
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <a href="https://geia.facilinformatica.com.br/Administracao/Login.aspx" target="_blank">
                  <button type="button" class="btn btn-info round" data-toggle="modal">
                    Ir para a área do cliente
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
</block-ui>
